import { BrowserRouter } from "react-router-dom";
import { LayoutWrapper } from "./router_layout";

const RouteProvider = () => {
  return (
    <BrowserRouter>
      <LayoutWrapper />
    </BrowserRouter>
  )
};

export default RouteProvider;
